import { Component, inject, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { fadeInUp400ms } from '../../../@vex/animations/fade-in-up.animation';
import { stagger40ms } from '../../../@vex/animations/stagger.animation';
import { DesignUtil } from '../../services/design-util.service';
import { Attribute } from '@eadsysteme/outboxclient-v1';
import { TranslocoDirective } from '@jsverse/transloco';
import { PageLayoutComponent } from '../../../@vex/components/page-layout/page-layout.component';
import { PageLayoutHeaderDirective } from '../../../@vex/components/page-layout/page-layout-header.directive';
import { PageLayoutContentDirective } from '../../../@vex/components/page-layout/page-layout-content.directive';
import { ContainerDirective } from '../../../@vex/directives/container/container.directive';

@Component({
	selector: 'vex-privacy',
	templateUrl: './privacy.component.html',
	styleUrls: ['./privacy.component.scss'],
	animations: [fadeInUp400ms, stagger40ms],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslocoDirective, PageLayoutComponent, PageLayoutHeaderDirective, PageLayoutContentDirective, ContainerDirective],
})
export class PrivacyComponent implements OnInit {
	private designUtil = inject(DesignUtil);
	privacy: Attribute = {};
	finishedLoading = false;

	ngOnInit(): void {
		for (const attribute of this.designUtil.currentDesign().attributes) {
			if (attribute.name === 'privacy') {
				this.privacy = attribute;
				this.finishedLoading = true;
			}
		}
	}
}
